<template>

    <router-view></router-view>

</template>
<script>
export default {
	beforeRouteUpdate(to, from, next) {
		if(to.name == 'Cadastro'){
			next({ name: 'CadastroUser' })
		}else{
			next()
		}
	},
	created() {
		if(this.$route.name == 'Cadastro'){
			this.$router.push({ name: 'CadastroUser' })
		}
	}
}
</script>